import _classCallCheck from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _createClass from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// Author Taehoon Moon 2014
import { Vex } from './vex';
import { StaveModifier } from './stavemodifier';
import { TextNote } from './textnote';
export var StaveText = /*#__PURE__*/function (_StaveModifier) {
  _inherits(StaveText, _StaveModifier);

  _createClass(StaveText, null, [{
    key: "CATEGORY",
    get: function get() {
      return 'stavetext';
    }
  }]);

  function StaveText(text, position, options) {
    var _this;

    _classCallCheck(this, StaveText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StaveText).call(this));

    _this.setAttribute('type', 'StaveText');

    _this.setWidth(16);

    _this.text = text;
    _this.position = position;
    _this.options = {
      shift_x: 0,
      shift_y: 0,
      justification: TextNote.Justification.CENTER
    };
    Vex.Merge(_this.options, options);
    _this.font = {
      family: 'times',
      size: 16,
      weight: 'normal'
    };
    return _this;
  }

  _createClass(StaveText, [{
    key: "getCategory",
    value: function getCategory() {
      return StaveText.CATEGORY;
    }
  }, {
    key: "setStaveText",
    value: function setStaveText(text) {
      this.text = text;
      return this;
    }
  }, {
    key: "setShiftX",
    value: function setShiftX(x) {
      this.shift_x = x;
      return this;
    }
  }, {
    key: "setShiftY",
    value: function setShiftY(y) {
      this.shift_y = y;
      return this;
    }
  }, {
    key: "setFont",
    value: function setFont(font) {
      Vex.Merge(this.font, font);
    }
  }, {
    key: "setText",
    value: function setText(text) {
      this.text = text;
    }
  }, {
    key: "draw",
    value: function draw(stave) {
      var ctx = stave.checkContext();
      this.setRendered();
      ctx.save();
      ctx.lineWidth = 2;
      ctx.setFont(this.font.family, this.font.size, this.font.weight);
      var text_width = ctx.measureText('' + this.text).width;
      var x;
      var y;
      var Position = StaveModifier.Position;
      var Justification = TextNote.Justification;

      switch (this.position) {
        case Position.LEFT:
        case Position.RIGHT:
          y = (stave.getYForLine(0) + stave.getBottomLineY()) / 2 + this.options.shift_y;

          if (this.position === Position.LEFT) {
            x = stave.getX() - text_width - 24 + this.options.shift_x;
          } else {
            x = stave.getX() + stave.getWidth() + 24 + this.options.shift_x;
          }

          break;

        case Position.ABOVE:
        case Position.BELOW:
          x = stave.getX() + this.options.shift_x;

          if (this.options.justification === Justification.CENTER) {
            x += stave.getWidth() / 2 - text_width / 2;
          } else if (this.options.justification === Justification.RIGHT) {
            x += stave.getWidth() - text_width;
          }

          if (this.position === Position.ABOVE) {
            y = stave.getYForTopText(2) + this.options.shift_y;
          } else {
            y = stave.getYForBottomText(2) + this.options.shift_y;
          }

          break;

        default:
          throw new Vex.RERR('InvalidPosition', 'Value Must be in Modifier.Position.');
      }

      ctx.fillText('' + this.text, x, y + 4);
      ctx.restore();
      return this;
    }
  }]);

  return StaveText;
}(StaveModifier);